import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { withRouter } from 'react-router-dom';
import _get from 'lodash/get';
import { searchSelectors, featureSelectors, accountSelectors, conferenceRemoteModerationSelectors } from '@lifesize/nucleus';
import actions, { loadContactManually } from 'actions/Contact';
import headerActions from 'actions/Header';
import GlobalSearch from 'components/GlobalSearch/GlobalSearch';
import { routes } from 'constants/Application';
import { GLOBAL_SEARCH_FORM } from 'constants/Header';
import { selectContact } from 'utils/contact-utils';

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleSelectContact: (contact) => {
    dispatch(loadContactManually(contact));
    selectContact(contact, ownProps.history.push);
    dispatch(reset(GLOBAL_SEARCH_FORM));
  },
  handleAudioCall: (contact) => {
    dispatch(reset(GLOBAL_SEARCH_FORM));
    dispatch(actions.startAudioCall(contact));
  },
  handleVideoCall: (contact) => {
    dispatch(reset(GLOBAL_SEARCH_FORM));
    dispatch(actions.startVideoCall(contact));
  },
  handleChat: (contact) => {
    dispatch(reset(GLOBAL_SEARCH_FORM));
    ownProps.history.push(routes.chat);
    dispatch(actions.chatWith(contact));
  },
  handleSetIsFocused: (isFocused) => {
    dispatch(headerActions.setFormFocus(isFocused));
    if (!isFocused) {
      dispatch(reset(GLOBAL_SEARCH_FORM));
    }
  },
  handleEnter: (selectedContact) => {
    dispatch(reset(GLOBAL_SEARCH_FORM));
    selectContact(selectedContact, ownProps.history.push);
  }
});

function getMaxItems(searchResults) {
  const resultLength = searchResults.length
    || 1;
  return Math.min(resultLength, 6);
}

function mapStateToProps(state) {
  const searchString = _get(state, 'app.form.search.values.globalSearch');
  const searchResults = searchSelectors.searchContacts(state);
  const selectionIndex = _get(state, 'app.dropdown.selectionIndex');
  const selectedContact = _get(searchResults[selectionIndex], 'contact');
  const isFocused = _get(state, 'app.header.isFocused');

  return {
    disabled: conferenceRemoteModerationSelectors.selectIsActive(state),
    hideContacts: _get(accountSelectors.getAccountFeatures(state),'hideContacts', false),
    hideMeetings: _get(accountSelectors.getAccountFeatures(state),'hideMeetings', false),
    hideRooms: _get(accountSelectors.getAccountFeatures(state),'hideRooms', false),
    isChatEnabled: featureSelectors.isChatEnabled(state) && accountSelectors.getAccountFeatures(state).isChatEnabled,
    isFocused,
    maxItems: getMaxItems(searchResults),
    searchResults,
    searchString,
    selectedContact
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GlobalSearch));
